var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"valign-wrapper",staticStyle:{"padding-left":"0","position":"fixed","top":"0","left":"0","bottom":"0","right":"0","background-color":"#1d2039"}},[_c('div')])
}]

export { render, staticRenderFns }